<template>
	<div id="app">
		<template v-if="!isLoginPage">
			<Nav />
			<slide-bar />
			<div class="content">
				<router-view />
			</div>
		</template>
		<wd-login title="豌豆公主入库管理后台" @login="login" v-else />
	</div>
</template>

<script>
import Nav from './components/nav.vue';
import SlideBar from './components/slidebar.vue';
// import LoginView from './views/login.vue';

export default {
	data() {
		return {
			isLoginPage: false
		};
	},
	mounted() {
		if(this.$route.path === '/login') {
			this.isLoginPage = true;
		} else {
			this.isLoginPage = false;
		}
	},
	components: {
		Nav,
		SlideBar
	},
	methods: {
		login(params) {
			let _this = this;
			this.$axios.commonApi.login({username: params.username, password: params.password}).then(res => {
				if(!res.code) {
					localStorage.setItem('username', params.username);
					_this.$router.push({
						path: '/receipt'
					});
					location.reload();
					// location.href = '/#/receipt';
				}
			});
		}
	}
};
</script>

<style>
@import url(./common.css);
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.content {
	padding: 84px 20px 20px 20px;
}
</style>
